export default __webpack_public_path__ + "static/media/rulesBgDec1.101be6d0.png";